import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import KobooTextField from '../Layout/KobooTextField.jsx';
import KobooButton from '../Layout/KobooButton';
import * as routes from '../../constants/routes';
import Spinner from '../Layout/Spinner';
import { getRenters } from '../../store/renters/actions';
import { getBikes, putBike } from '../../store/bikes/actions';
import { getSites } from '../../store/sites/actions';
import Loader from '../Layout/Loader';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import { handleError } from '../../store/infos/actions';
import {SiteTable} from "../Site/SiteTable";

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  menu: {
    width: 200,
  },
});

const getStateByBikeInfo = bikeInfo => ({
  site_id: bikeInfo.site_id ? bikeInfo.site_id : '',
  renter_id: bikeInfo.renter_info_id ? bikeInfo.renter_info_id : '',
  mac_address: bikeInfo.mac_address ? bikeInfo.mac_address : '',
  padlock_number: bikeInfo.padlock_number ? bikeInfo.padlock_number : '',
  number: bikeInfo.number ? bikeInfo.number : '',
  rfid: bikeInfo.rfid ? bikeInfo.rfid : '',
  type: bikeInfo.type ? bikeInfo.type : 0,
  padlock_type: bikeInfo.padlock_type ? bikeInfo.padlock_type : 0,
  manufacturer_id: bikeInfo.manufacturer_id ? bikeInfo.manufacturer_id : '',
  is_electric: bikeInfo.is_electric ? bikeInfo.is_electric : false,
});

const INITIAL_STATE = {
  site_id: '',
  renter_id: '',
  mac_address: '',
  rfid: '',
  type: 0,
  padlock_number: '',
  number: '',
  role: ROLE_USER,
  freeze: false,
  padlock_type: 0,
  manufacturer_id: '',
  is_electric: 0,
  order: 'desc',
  orderBy: 'name',
};

export class EditBikeForm extends Component {
  static propTypes = {
    authUser: PropTypes.object,
    match: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = { ...INITIAL_STATE, bike_id: this.props.match.params.bikeId };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (
      props.authUser
      && props.roles
      && props.errorRenters === null
      && props.errorSites === null
      && props.errorBikes === null
    ) {
      const role = props.roles[props.authUser.uid];
      newState = {...newState, role:role};
      if (!props.renters && !props.pendingRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites) {
        props.getSites(props.authUser.ma, role);
      }
      if (!props.bikes && !props.pendingBikes) {
        props.getBikes(props.authUser.ma, role);
      }
    }

    if (props.bikes && state.site_id === INITIAL_STATE.site_id && props.sites) {
      const foundBike = props.bikes.find(bike => bike.id === state.bike_id);
      if (foundBike) {
        newState = {...newState, ...getStateByBikeInfo(foundBike)};
      }
    }
    return newState;
  }

  onSubmit = (event) => {
    const {
      site_id,
      renter_id,
      mac_address,
      padlock_number,
      number,
      rfid,
      type,
      padlock_type,
      manufacturer_id,
      is_electric
    } = this.state;
    if (mac_address && !mac_address.match(/..:..:..:..:..:../)) {
      this.props.handleError({message: 'L\'adresse MAC doit être au format AA:AA:AA:AA:AA:AA.'});
    } else {
      this.props.putBike(
        this.props.authUser.ma, this.state.bike_id,
        {
          renter_info_id: renter_id,
          site_id: site_id ? site_id : '',
          mac_address: mac_address ? mac_address : null,
          padlock_number: padlock_number ? padlock_number : null,
          number: number || null,
          rfid: rfid ? rfid : null,
          type: type,
          padlock_type: padlock_type,
          manufacturer_id: manufacturer_id ? manufacturer_id : '',
          is_electric: is_electric
        },
      )
        .then(value => {
          if (value) {
            this.props.history.push(routes.BIKES);
          }
        });
    }
    event.preventDefault();
  };

  onSelectRenter = (event) => {
    this.setState({renter_id: event.target.value, site_id: null});
  };


  render() {
    const {
      site_id,
      renter_id,
      mac_address,
      padlock_number,
      number,
      rfid,
      role,
      type,
      padlock_type,
      manufacturer_id,
      is_electric,
      order,
      orderBy
    } = this.state;

    const {
      classes, renters, pending, sites,
    } = this.props;

    const isInvalid = renter_id === '';

    if (pending) {
      return (<Loader />);
    } else if (renters && renters.length) {
      return (
        <form onSubmit={this.onSubmit} style={styles.center}>
          {role === ROLE_ADMIN &&
          <TextField
            id="renter_id"
            type="text"
            select
            label="Loueur"
            className={classes.textField}
            value={renter_id}
            onChange={this.onSelectRenter}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            helperText="Choisissez le loueur"
            margin="normal"
          >
            {renters.map(renter => (
              <MenuItem key={renter.id} value={renter.id}>
                {renter.name}
              </MenuItem>
            ))}
          </TextField>
          }
          <TextField
            id="site_id"
            type="text"
            select
            label="Site"
            className={classes.textField}
            value={site_id}
            onChange={event => this.setState({site_id: event.target.value})}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            helperText="Choisissez le site"
            margin="normal"
          >
            {sites.filter(site => site.renter_info_id === renter_id)
              .sort((a, b) => SiteTable.sort(a, b, orderBy, order))
              .map(site => (
              <MenuItem key={site.id} value={site.id}>
                {site.name}
              </MenuItem>
            ))}
          </TextField>
          <KobooTextField
            label="Adresse MAC"
            id="mac_address"
            onChange={event => this.setState({mac_address: event.target.value})}
            value={mac_address}
          />
          <KobooTextField
            label="Numéro de cadenas"
            id="padlock_number"
            onChange={event => this.setState({padlock_number: event.target.value})}
            value={padlock_number}
          />
          <KobooTextField
            label="Numéro de vélo"
            id="bike_number"
            onChange={event => this.setState({number: event.target.value})}
            value={number}
          />
          <KobooTextField
            label="RFID"
            id="rfid"
            onChange={event => this.setState({rfid: event.target.value})}
            value={rfid}
          />
          <TextField
            id="type"
            type="text"
            select
            label="Type de public"
            className={classes.textField}
            value={type}
            onChange={event => this.setState({type: event.target.value})}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            margin="normal"
          >
            <MenuItem key='type_adult' value={0}>
              Adulte
            </MenuItem>
            <MenuItem key='type_children' value={1}>
              Enfant
            </MenuItem>
          </TextField>
          <TextField
            id="is_electric"
            type="text"
            select
            label="Type de vélo"
            className={classes.textField}
            value={is_electric}
            onChange={event => this.setState({is_electric: event.target.value})}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            margin="normal"
          >
            <MenuItem key='type_mechanic' value={false}>
              Mécanique
            </MenuItem>
            <MenuItem key='type_electric' value={true}>
              Électrique
            </MenuItem>
          </TextField>

          <TextField
            id="padlock_type"
            type="text"
            select
            label="Type de cadenas"
            className={classes.textField}
            value={padlock_type}
            onChange={event => this.setState({padlock_type: event.target.value})}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            helperText="Choisissez le type du cadenas"
            margin="normal"
          >
            <MenuItem key='type_old' value={0}>
              Ancien
            </MenuItem>
            <MenuItem key='type_mose' value={1}>
              Koboo1
            </MenuItem>
            <MenuItem key='no_lock' value={2}>
              Pas de cadenas
            </MenuItem>
          </TextField>
          <KobooTextField
            label="Identifiant Constructeur"
            id="manufacturer_id"
            onChange={event => this.setState({manufacturer_id: event.target.value})}
            value={manufacturer_id}
          />
          <KobooButton disabled={this.props.sending || isInvalid} type="submit">
            {this.props.sending ?
              <Spinner style={{ parent: { margin: '4px auto 0' }, child: {} }}/> : 'Modifier'}
          </KobooButton>
        </form>
      );
    }
    return (<Loader />);
  }
}

function mapStateToProps(state) {
  return {
    roles: state.roles.content,
    authUser: state.users.authUser,
    renters: state.renters.content,
    bikes: state.bikes.content,
    sites: state.sites.content,
    pending: state.renters.pending || state.bikes.pending || state.sites.pending,
    sending: state.bikes.sending,
    pendingRenters: state.renters.pending,
    pendingBikes: state.bikes.pending,
    pendingSites: state.sites.pending,
    errorRenters: state.renters.error,
    errorSites: state.sites.error,
    errorBikes: state.bikes.error
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    putBike, getRenters, getSites, getBikes, handleError
  }),
)(EditBikeForm);



// WEBPACK FOOTER //
// ./src/components/Bike/EditBikeForm.jsx